import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import {
  clueGet,
  clueDelete,
  clueToValid,
  clueToFuture,
  clueDetail,
  parentLabelList
} from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { ClueManage, ClueManageParams } from '@/typings/api/marketingManage'
import { DcMessage } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { DropListType } from '@/typings/common'
import ClueMergeButton from '@/components/ClueMergeButton'
import ImportBtn from '@/components/ImportBtn'
import CustomerArea from '@/components/CustomerArea'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import InvalidModel from '@/views/yuntuSales/marketLeads/components/invalidModel.vue'
import RelevanceClue from '@/components/MarketLeads/RelevanceClue/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { cloneDeep } from 'lodash-es'
import PutIn from '@/components/MarketLeads/PutIn/index.vue'
import CustomPut from '@/components/MarketLeads/CustomPut/index.vue'
import {
  clueStatus,
  clueType,
  linkMethods,
  lbuCustomerAllStatusEnum,
  lbuCustomerStageEnum
} from '@/views/marketing/commonEnum/dataConfig'

const __default__ = { name: 'DcCosLbuLeadManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const invalidModelRef = ref()
const relevanceClue = ref()
const tableRef = ref()
const searchFrom = ref<ClueManageParams>({
  contact: {
    type: 1
  },
  track: {},
  business: {}
})
const alltagList = ref<DropListType>([])
const tagList = ref<DropListType>([])
const selectedRows = ref<any[]>([])
const paramCodeData = reactive<{
  zbu_product_type_lbu: []
  zbu_channel_detail_lbu: []
  zbu_demand_info_lbu: []
  zbu_monthly_sales_lbu: []
  zbu_service_demand_lbu: []
  zbu_existing_cooperation_lbu: []
  zbu_customer_area_lbu: []
  zbu_sales_category_lbu: []
}>({
  zbu_product_type_lbu: [], // 产品货型
  zbu_channel_detail_lbu: [], // 销售平台
  zbu_demand_info_lbu: [], // 需求海外仓
  zbu_monthly_sales_lbu: [], // 跨境月销售额
  zbu_service_demand_lbu: [], // 服务需求
  zbu_existing_cooperation_lbu: [], // 是否已有合作
  zbu_customer_area_lbu: [], // 客户区域
  zbu_sales_category_lbu: [] // 销售品类
})
const statusList = computed(() => {
  const stage = searchFrom.value.track?.stage
  const filterState = [1, 8, 2]
  if (stage) {
    // 待领取，已转换，待跟进 不显示 1，8，2
    const min = (stage - 1) * 10 - 1
    const max = stage * 10 - 1
    const result = lbuCustomerAllStatusEnum.filter(
      (item: any) => item.value > min && item.value < max && !filterState.includes(item.value)
    )
    // searchFrom.value.statusList = []
    return result
  } else {
    return lbuCustomerAllStatusEnum.filter((item: any) => !filterState.includes(item.value))
  }
})
// 列表
const fetch = (params: object, callBack: (res: any) => void) => {
  clueGet(params).then((res) => {
    callBack(res)
  })
}
const showMask = (row: ClueManage, callBack: (res: any) => void) => {
  clueDetail({
    clueId: row.clueId
  }).then((res) => {
    callBack(res.data.contact)
  })
}
// 获取标签下拉框
const getTag = () => {
  parentLabelList().then((res) => {
    tagList.value = res.data
    alltagList.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
  getTag()
})
// 标签筛选
const tagSearch = (searchText: string) => {
  const list = alltagList.value.filter((v: any) => v.name?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
  tagList.value = !searchText ? cloneDeep(alltagList.value) : cloneDeep(list)
}
const tagFocus = () => {
  if (!searchFrom.value.tag) {
    tagSearch('')
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_product_type_lbu',
      'zbu_channel_detail_lbu',
      'zbu_demand_info_lbu',
      'zbu_monthly_sales_lbu',
      'zbu_service_demand_lbu',
      'zbu_existing_cooperation_lbu',
      'zbu_sales_category_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const search = () => {
  tableRef.value.search()
}
// 新增
const handleAdd = () => {
  router.push({
    path: '/lbu/leadManage/add'
  })
}
// 编辑
const handleEdit = (row: ClueManage) => {
  router.push({
    path: '/lbu/leadManage/edit',
    query: {
      clueId: row.clueId
    }
  })
}
// 置为无效
const handleInValid = (row?: ClueManage) => {
  let result = []
  if (row && row.clueId) {
    result.push(row)
  } else {
    result = selectedRows.value
  }
  invalidModelRef.value.toggle(result)
}
// 置为有效
const handleValid = (row?: ClueManageParams) => {
  let ids: any[] = []
  if (row && row.clueId) {
    ids.push(row.clueId)
  } else {
    ids = selectedRows.value.map((item) => item.clueId)
  }
  // 未投放的无效和新线索
  if (!ids || ids.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  Modal.switch({
    title: '确定置为有效线索？',
    onOk() {
      clueToValid({ clueIdList: ids }).then(() => {
        DcMessage.success('置为有效成功')
        success()
      })
    }
  })
}
// 置为未来线索
const handleFuture = (row?: ClueManageParams) => {
  let ids: any[] = []
  if (row && row.clueId) {
    ids.push(row.clueId)
  } else {
    ids = selectedRows.value.map((item) => item.clueId)
  }
  // 未投放的无效和新线索
  if (!ids || ids.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  Modal.switch({
    title: '确定置为未来线索？',
    onOk() {
      clueToFuture({ clueIdList: ids }).then(() => {
        DcMessage.success('置为未来线索成功')
        success()
      })
    }
  })
}
// 删除
const handleDelete = (row?: ClueManage) => {
  if (!row && !selectedRows.value?.length) {
    return DcMessage.error('请选择要删除的数据')
  }
  // 过滤出有效线索、新线索
  let name: any = []
  let clueIdList: any = []
  if (row && row.clueId) {
    name = [row.customerName]
    clueIdList = [row.clueId]
  } else {
    selectedRows.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      name.push(item.customerName)
    })
  }
  Modal.delete({
    name: name.join('，'),
    onOk() {
      clueDelete({
        clueIdList
      }).then(() => {
        tableRef.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
// 关联线索
const handleRelevance = (row?: ClueManage) => {
  relevanceClue.value.showModal(row)
}
const onSelectChange = (selectedRowKeys: string[], rows: ClueManage[]) => {
  selectedRows.value = rows
}

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/leadManage/view',
    query: ['clueId', 'track.acceptorClueId'],
    fixed: 'left',
    width: 200
  },
  {
    title: '来源渠道',
    dataIndex: 'channel',
    width: 200
  },
  {
    title: '客户办公地',
    dataIndex: 'customerOffice'
  },
  {
    title: '标签',
    dataIndex: 'customerTag'
  },
  {
    title: '联系人名称',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '产品货型',
    dataIndex: ['business', 'cargoType'],
    dicData: paramCodeData.zbu_product_type_lbu
  },
  {
    title: '销售平台',
    dataIndex: ['business', 'salePlatform'],
    dicData: paramCodeData.zbu_channel_detail_lbu
  },
  {
    title: '需求海外仓',
    dataIndex: ['business', 'warehouse'],
    dicData: paramCodeData.zbu_demand_info_lbu
  },
  {
    title: '目的国家',
    dataIndex: ['business', 'destinationCountry']
  },
  {
    title: '发货地',
    dataIndex: ['business', 'shipAddress']
  },
  {
    title: '销售品类',
    dataIndex: ['business', 'salesCategory'],
    dicData: paramCodeData.zbu_sales_category_lbu
  },
  {
    title: '跨境月销售额',
    dataIndex: ['business', 'monthSales'],
    dicData: paramCodeData.zbu_monthly_sales_lbu
  },

  {
    title: '服务需求',
    dataIndex: ['business', 'serviceNeeds'],
    dicData: paramCodeData.zbu_service_demand_lbu
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: clueType
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus',
    dicData: clueStatus
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '当前跟进人',
    dataIndex: ['track', 'followerName']
  },
  {
    title: '客户区域',
    dataIndex: ['track', 'customerRegion']
  },
  {
    title: '客户阶段',
    dataIndex: ['track', 'stage'],
    dicData: lbuCustomerStageEnum,
    width: 190
  },
  {
    title: '客户状态',
    dataIndex: ['track', 'status'],
    dicData: lbuCustomerAllStatusEnum,
    width: 190
  },
  {
    title: '客户代码',
    dataIndex: ['track', 'customerNumber'],
    width: 190
  },
  {
    title: '领取时间',
    dataIndex: ['track', 'salesCollectionTime'],
    width: 190
  },
  {
    title: '转潜在时间',
    dataIndex: ['track', 'turnPotentialTime'],
    width: 190
  },
  {
    title: '成交时间',
    dataIndex: ['track', 'turnCustomerTime'],
    width: 190
  },
  {
    title: '成交额',
    dataIndex: ['track', 'clinchAmount']
  },
  {
    title: '无效时间',
    dataIndex: ['track', 'invalidTime'],
    width: 190
  },
  {
    title: '无效原因',
    dataIndex: ['track', 'invalidReason']
  },
  {
    title: '市场线索ID',
    dataIndex: 'clueId'
  },
  {
    title: '销售线索ID',
    dataIndex: ['track', 'acceptorClueId']
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 220
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "clueId",
            "row-selection": { onChange: onSelectChange },
            columns: columns.value,
            serial: "",
            onFetch: fetch,
            search: searchFrom.value,
            "onUpdate:search": _cache[22] || (_cache[22] = ($event: any) => ((searchFrom).value = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuLeadManage",
            onMask: showMask
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "线索状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: searchFrom.value.clueStatus,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.clueStatus) = $event)),
                        optionType: "button",
                        onChange: search,
                        options: _unref(clueStatus)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "线索类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.clueType,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.clueType) = $event)),
                        placeholder: "请选择",
                        allowClear: "",
                        options: _unref(clueType)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "市场线索ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.clueId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.clueId) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.createStartTime,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.createStartTime) = $event)),
                        endTime: searchFrom.value.createEndTime,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.createEndTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: searchFrom.value.channelList,
                            "onUpdate:ids": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.channelList) = $event)),
                            appId: "cos_zbu",
                            paramCode: "zbu_source_channel_lbu",
                            style: {"width":"33%"}
                          }, null, 8, ["ids"]),
                          _createVNode(_component_a_input, {
                            value: searchFrom.value.channelExplain,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.channelExplain) = $event)),
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchFrom.value.contact.type,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.contact.type) = $event)),
                            options: _unref(linkMethods),
                            style: {"width":"33%"},
                            placeholder: "请选择"
                          }, null, 8, ["value", "options"]),
                          _createVNode(_component_a_input, {
                            value: searchFrom.value.contact.keyword,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.value.contact.keyword) = $event)),
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "标签" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_auto_complete, {
                        value: searchFrom.value.tag,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom.value.tag) = $event)),
                        options: tagList.value,
                        fieldNames: { label: 'name', value: 'name' },
                        placeholder: "请输入",
                        onSearch: tagSearch,
                        onFocus: tagFocus
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "投放时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.track.startPushTime,
                        "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((searchFrom.value.track.startPushTime) = $event)),
                        endTime: searchFrom.value.track.endPushTime,
                        "onUpdate:endTime": _cache[12] || (_cache[12] = ($event: any) => ((searchFrom.value.track.endPushTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "销售线索ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.track.acceptorClueId,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((searchFrom.value.track.acceptorClueId) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        appId: "cos_lbu",
                        type: "search",
                        multiple: false,
                        ids: searchFrom.value.track.customerRegionList,
                        "onUpdate:ids": _cache[14] || (_cache[14] = ($event: any) => ((searchFrom.value.track.customerRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前跟进人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.track.follower,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((searchFrom.value.track.follower) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户阶段" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.track.stage,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((searchFrom.value.track.stage) = $event)),
                        placeholder: "请选择",
                        "allow-clear": "",
                        options: _unref(lbuCustomerStageEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.track.statusList,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((searchFrom.value.track.statusList) = $event)),
                        mode: "multiple",
                        maxTagCount: "responsive",
                        placeholder: "请选择",
                        "allow-clear": "",
                        options: statusList.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.track.customerNumber,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((searchFrom.value.track.customerNumber) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.createBy,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((searchFrom.value.createBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新增 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(ClueMergeButton), {
                data: selectedRows.value,
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode("合并")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'lbu_lead_merge_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleInValid }, {
                default: _withCtx(() => [
                  _createTextVNode("置为无效")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_invalid_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleValid }, {
                default: _withCtx(() => [
                  _createTextVNode(" 置为有效 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_valid_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleFuture }, {
                default: _withCtx(() => [
                  _createTextVNode(" 置为未来线索 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_future_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(PutIn, {
                data: selectedRows.value,
                appId: "cos_lbu",
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode("投放")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'lbu_lead_release_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(CustomPut, {
                data: selectedRows.value,
                onSuccess: success,
                appId: "cos_lbu"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量投放")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'lbu_lead_release_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                action: "/zbu/api/clue/import",
                templateUrl: "/zbu/api/clue/template/download",
                onSuccess: _cache[20] || (_cache[20] = ($event: any) => (success('search')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_import_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_zbu",
                taskType: "101",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_lead_export_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                danger: "",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (handleDelete()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_del_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'customerTag')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text && Array.isArray(text) && text.length ? text.join('、') : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channel')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 1,
                    appId: "cos_zbu",
                    paramCode: "zbu_source_channel_lbu",
                    value: text,
                    desc: record.channelExplain
                  }, null, 8, ["value", "desc"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerOffice')
                ? (_openBlock(), _createBlock(_unref(CustomerArea), {
                    key: 2,
                    type: "text",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (Array.isArray(column.dataIndex) && column.dataIndex.join('.') === 'track.customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 3,
                    appId: "cos_lbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 4 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        disabled: record.clueStatus === 0 ? false : true,
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])), [
                        [_directive_permission, 'lbu_lead_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleValid(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 置为有效 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, record.clueStatus === 0 && record.clueType !== 2],
                        [_directive_permission, 'lbu_lead_valid_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleInValid(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 置为无效 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, record.clueStatus === 0 && record.clueType !== 3],
                        [_directive_permission, 'lbu_lead_invalid_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleFuture(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 置为未来线索 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, record.clueStatus === 0 && record.clueType !== 1],
                        [_directive_permission, 'lbu_lead_future_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleRelevance(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 关联线索 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_lead_relevance_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_lead_del_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"]),
          _createVNode(InvalidModel, {
            ref_key: "invalidModelRef",
            ref: invalidModelRef,
            onSuccess: success
          }, null, 512),
          _createVNode(RelevanceClue, {
            ref_key: "relevanceClue",
            ref: relevanceClue,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})